import styled from 'styled-components';
import {
  white, black, red, blue, darkBlue, roboto, tekoMedium, lightGrey, openSansBold, openSans,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

export const Container = styled.div`
  position: relative;
  border: 2px solid #dcdcdc;
  height: 100%;
  padding: 0;
  cursor: pointer;

  @media (max-width: ${mobile.max}px) {
    border: none;
    padding: 0 0 2vw 0;
    width: 100%;
    height: auto;
  }
`;

export const Content = styled.div`
  padding: 27px 17px 27px 17px;
  text-align: left;
  margin: 0 auto;
  background: ${white};
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;

  .source {
    ${openSans}
    font-size: 12px;
    color: ${black};
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-bottom: 45px;
  }

  p {
    color: ${black};
    font-size: 12px;
  }
`;

export const Title = styled.h3`
  color: ${blue};
  ${tekoMedium} font-size: 27px;
  letter-spacing: 1.81px;
  line-height: 30px;
`;

export const Author = styled.span`
  color: ${black};
  ${roboto} font-style: italic;
  font-size: 12px;
  letter-spacing: 0.4px;
  line-height: 24px;
  margin-right: 5px;
`;

export const Date = styled.span`
  color: ${black};
  ${roboto} font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.4px;
  line-height: 24px;
  margin-left: 5px;
`;

export const Media = styled.div`
  width:  100%;
  background-image: url('${({ img }) => img}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    padding-bottom: 70%;
  }

  &:before {
    content: '';
    background-image: url('/images/play-icon.png');
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
  }
`;

export const OpenArticle = styled.span`
  display: inline-block;
  width: 70px;
  text-align: left;
  color: ${darkBlue};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.8px;
  line-height: 24px;
  text-decoration: none;
  cursor: pointer;
  border-bottom: ${red} 1px solid;
  a {
    color: ${darkBlue};
  }
`;

export const ModalButton = styled.button`
  border: none;
  cursor: pointer;
  width: 100%;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Shadow = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 25;
  overflow-y: scroll;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideoModal = styled.div`
  z-index: 100;
  position: relative;
  background: white;
  width: 144.44vh;
  height: 80vh;
  max-width: 1120px;
  max-height: 800px;
  cursor: initial;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${mobile.max}px) {
    width: 100%;
    height: calc(51vw + 80px);
    padding: 25px 0;
    align-items: flex-end;
  }

  button {
    display: block;
    float: right;
    background: transparent;
    border: none;
    position: absolute;
    top: 15px;
    right: 15px;

    &:hover {
      cursor: pointer;
    }
  }

  img {
    width: 100%;
    height: auto;
  }

  iframe {
    max-width: 1090px;
    max-height: 613px;
    width: 124.44vh;
    height: 70vh;

    @media(max-width: ${mobile.max}px) {
      width: 100vw;
      height: 56.25vw;
    }
  }
`;

export const MobileArticle = styled.div`
  padding: 30px 145px 30px 30px;
  text-align: left;
  position: relative;
  display: block;
  min-height: 160px;
  border-top: 1px solid ${lightGrey};

  .date {
    ${openSansBold}
    font-size: 12px;
    color: #050709;
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .title {
    ${tekoMedium}
    font-size: 19px;
    color: #26397E;
    letter-spacing: 1.57px;
    line-height: 23px;
    text-transform: uppercase;
  }

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid ${lightGrey};
  }

  .image {
    background: url('${({ img }) => img}');
    background-position: center center;
    background-size: cover;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 30px;
    right: 30px;

    @media(max-width: ${mobile.max}px) {
      &::after {
        content: url(/images/play-icon.png);
        display: block;
        margin: 25px;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/article-list/styles/video-article.style.js